import { OFFER_PROMOTION_TYPE } from '../../../../../offer'
import { type StoryblokProductSearchFiltersType } from '../StoryblokProductSearchFilters.types'

export const storyblokProductSearchFiltersGetPromotion = (): Partial<
  Pick<StoryblokProductSearchFiltersType, 'promotion'>
> => {
  return {
    promotion: [OFFER_PROMOTION_TYPE.ONE_PLUS_ONE, OFFER_PROMOTION_TYPE.BUNDLE],
  }
}
